// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api.chizhik-tram.ru',
  socketUrl: 'https://api.chizhik-tram.ru',
  vectorMap: {
    url: "https://api.chizhik-tram.ru",
    stylePath: "/styles/basic/style.json"
  },
  map: {
    stop: {
      style: {
        default: {
          color: 'rgb(98, 107, 111)',
          weight: 2,
          radius: 4,
          fillColor: 'white',
          fillOpacity: 1
        },
        selected: {
          color: 'rgb(167, 200, 82)',
          weight: 3,
          radius: 5,
          fillColor: 'white',
          fillOpacity: 1
        },
        highlighted: {
          color: 'rgb(98, 107, 111)',
          weight: 3,
          radius: 5,
          fillColor: 'white',
          fillOpacity: 1
        },
        edge: {
          start: {
            color: 'rgb(98, 107, 111)',
            weight: 3,
            radius: 8,
            fillColor: 'rgb(167, 200, 82)',
            fillOpacity: 1
          },
          finish: {
            color: 'rgb(98, 107, 111)',
            weight: 8,
            radius: 6,
            fillColor: 'rgb(167, 200, 82)',
            fillOpacity: 1
          },
          gobetweeen: {
            color: 'rgb(98, 107, 111)',
            weight: 5,
            radius: 5,
            fillColor: 'rgb(167, 200, 82)',
            fillOpacity: 1
          }
        }
      }
    },
    rail: {
      style: {
        default: {
          color: 'rgb(98, 107, 111',
          weight: 3,
        },
        selected: {
          color: 'rgb(167, 200, 82)',
          weight: 3,
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/environments/environment.ts